import React, { useMemo } from 'react';

// store
import { useStoreValue } from '../../../../../../../../store';
import { armExternalDrag } from '../../../../../../../../store/externalDragStore';

// hooks
import useSelection from '../../../../../../../../hooks/useSelection';
import useCueItemMenu from '../../../../../../../../hooks/useCueItemMenu';
import { SELECTION_KINDS } from '../../../../../../../../helpers/selection';

// tools
import getDateFromISOstring from '../../../../../../../../helpers/getDateFromISOstring';

// components
import BadgeTrack from '../../../../../../../../components/BadgeTrack';
import TripleDotsIcon from '../../../../../../../../icons/TripleDotsIcon';
import ButtonIconContextMenu from '../../../../../../../../components/ButtonWrapper/components/ButtonIconContextMenu';

const ListOfReferenceItems = () => {
    const cueSheet = useStoreValue('cueSheet');
    const referencesItems = useMemo(() => cueSheet.filter(o => o.cueType === 'REFERENCE'), [cueSheet]);

    const orderedIds = useMemo(() => referencesItems.map(item => item.id), [referencesItems]);
    const { isSelected, select } = useSelection(SELECTION_KINDS.CUE, orderedIds);
    const menuItemsFor = useCueItemMenu();

    return(
        referencesItems.map(item => <li key={`music_ref_${item.id}`}
            className={`auxListItem${isSelected(item.id) ? ' auxListItem--selected' : ''}`}
            aria-selected={isSelected(item.id)}
            style={{ cursor: 'grab' }}
            onMouseDown={(e) => {
                if (e.button !== 0) return;
                e.preventDefault();
                // The drag only starts once the pointer moves, so a plain press
                // stays a click and selects the item instead.
                armExternalDrag(item, e);
            }}
            onClick={(e) => {
                if (e.target.closest('button, a, input, dialog')) return;
                select(item.id, e);
            }}
        >
            <div>
                <BadgeTrack>{item.label}</BadgeTrack>
            </div>
            <div className="title">
                <h3>{item.title}</h3>
                <span>{item.timecode}</span>
            </div>
            <div className="meta lastGroup">
                        <span>{getDateFromISOstring(item.date, {
                            day: '2-digit',
                            month: 'short'
                        })}</span>
                <ButtonIconContextMenu menuItems={menuItemsFor(item)}>
                    <TripleDotsIcon/>
                </ButtonIconContextMenu>
            </div>
        </li>)
    )
}

export default ListOfReferenceItems;